import React from "react";

export function DarkIcon({ color }: { color: string }) {
  const fillColor = color === "currentColor" ? "none" : "#26c496";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill={fillColor}
      style={{ fillOpacity: 0.3 }}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
    </svg>
  );
}
